import type { ReactNode } from 'react';

import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';

/**
 * Custom I18nProvider for ARI Cloud that uses the ARI-specific i18n configuration
 * with HTTP backend loading translations from /public/locales/
 */
export function AriI18nProvider({ children }: { children: ReactNode }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
